import { render } from "./InitiativeEditor.vue?vue&type=template&id=03435de2"
import script from "./InitiativeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./InitiativeEditor.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/InitiativeEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03435de2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03435de2', __exports__)) {
    api.reload('03435de2', __exports__)
  }
  
  module.hot.accept("./InitiativeEditor.vue?vue&type=template&id=03435de2", () => {
    api.rerender('03435de2', render)
  })

}


export default __exports__